import { AxiosError } from 'axios';
import { GET_GROUP_EXAM_REGISTRATION_FEE_DETAILS } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_GROUP_EXAM_REGISTRATION_FEE_DETAILS_QUERY_KEY } from '../../constants/queryKeys';
import {ExamGroupExamLevelFeeResponse, ExamPayment, GenericErrorResponse} from '../typings';

// =============================================================================
// Query
// =============================================================================

interface GetExamRegistrationFeeDetailResponse {
  selectedSubjects: SelectedSubjects[];
  groupedLevelFees: ExamGroupExamLevelFeeResponse[];
  gstRegistrationNumber: string;
  payment: ExamPayment;
  bankTransferOption: boolean;
  candidatePayOption: boolean;
  coordinatorPay: boolean;
}

interface Input {
  onSuccess?: (data: GetExamRegistrationFeeDetailResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
  examRegUuid: string;
  enabled?: boolean;
}

interface OptionalPapers {
  uuid: string;
  modeOfAssessment: string;
  paperNo: string;
  status?: string;
  selected: boolean;
}
interface SelectedSubjects {
  subjectName: string;
  subjectCode: string;
  subjectLevel: string;
  examSeries: string;
  examLevel: string;
  language: string;
  optionalPapers: OptionalPapers[];
  fee: string;
}

export const useGetExamRegistrationFeeDetails = ({
  uuid,
  examRegUuid,
  onSuccess,
  onError,
  enabled,
}: Input) => {
  const getExamRegistrationFeeDetails = async () => {
    const res = await axiosClient.get<GetExamRegistrationFeeDetailResponse>(
      GET_GROUP_EXAM_REGISTRATION_FEE_DETAILS(uuid, examRegUuid)
    );
    return res.data;
  };
  return useCustomQuery(
    [GET_GROUP_EXAM_REGISTRATION_FEE_DETAILS_QUERY_KEY, examRegUuid],
    getExamRegistrationFeeDetails,
    {
      onSuccess,
      onError,
      enabled,
    }
  );
};
